(() => {
  if (window.AlyxenDeliveryEstimateInitialized) return;

  window.AlyxenDeliveryEstimateInitialized = true;

  const addBusinessDays = (startDate, numberOfDays) => {
    const date = new Date(startDate);
    date.setHours(12, 0, 0, 0);

    let daysAdded = 0;

    while (daysAdded < numberOfDays) {
      date.setDate(date.getDate() + 1);

      const dayOfWeek = date.getDay();

      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded += 1;
      }
    }

    return date;
  };

  const renderDeliveryRanges = () => {
    const locale = document.documentElement.lang || navigator.language || 'en';

    const formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short'
    });

    document
      .querySelectorAll('[data-alyxen-delivery-range]')
      .forEach((element) => {
        const minimumDays =
          Number.parseInt(element.dataset.minBusinessDays, 10) || 4;
        const maximumDays =
          Number.parseInt(element.dataset.maxBusinessDays, 10) || 12;

        const safeMaximumDays = Math.max(minimumDays, maximumDays);
        const today = new Date();
        const earliestDate = addBusinessDays(today, minimumDays);
        const latestDate = addBusinessDays(today, safeMaximumDays);

        const range =
          typeof formatter.formatRange === 'function'
            ? formatter.formatRange(earliestDate, latestDate)
            : `${formatter.format(earliestDate)}–${formatter.format(latestDate)}`;

        if (element.textContent !== range) {
          element.textContent = range;
        }
      });
  };

  const renderShippingTaxEmphasis = () => {
    document
      .querySelectorAll('.alyxen-cart-tax-note > span')
      .forEach((element) => {
        if (element.dataset.alyxenTaxEmphasis === 'true') return;

        const text = element.textContent.trim();
        const sentenceEnd = text.search(/[.!?。！？]/);

        if (sentenceEnd < 0) return;

        const emphasizedText = text.slice(0, sentenceEnd + 1);
        const remainingText = text.slice(sentenceEnd + 1).trim();
        const strong = document.createElement('strong');

        strong.textContent = emphasizedText;
        element.textContent = '';
        element.append(strong);

        if (remainingText) {
          element.append(document.createTextNode(` ${remainingText}`));
        }

        element.dataset.alyxenTaxEmphasis = 'true';
      });
  };

  const renderCartEnhancements = () => {
    renderDeliveryRanges();
    renderShippingTaxEmphasis();
  };

  let renderScheduled = false;

  const scheduleRender = () => {
    if (renderScheduled) return;

    renderScheduled = true;

    window.requestAnimationFrame(() => {
      renderScheduled = false;
      renderCartEnhancements();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender, {
      once: true
    });
  } else {
    scheduleRender();
  }

  const observerRoot =
    document.querySelector('.shopify-section--cart-drawer') || document.body;

  if (observerRoot) {
    new MutationObserver(scheduleRender).observe(observerRoot, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('cart:change', scheduleRender);
  document.addEventListener('cart:refresh', scheduleRender);
})();
